import { format } from 'date-fns';

/**
 * 職務経歴書PDFのファイル名を生成します。
 * 例: 職務経歴書_2025年11月2日.pdf
 *
 * @param date 日付（省略時は現在日時）
 * @returns フォーマット済みのファイル名
 */
export function generateResumePdfFileName(date: Date = new Date()): string {
  const formattedDate = format(date, 'yyyy年M月d日');
  return `職務経歴書_${formattedDate}.pdf`;
}

/**
 * 履歴書PDFのファイル名を生成します。
 * 例: 履歴書_2025年11月2日.pdf
 *
 * @param date 日付（省略時は現在日時）
 * @returns フォーマット済みのファイル名
 */
export function generateRirekishoPdfFileName(date: Date = new Date()): string {
  const formattedDate = format(date, 'yyyy年M月d日');
  return `履歴書_${formattedDate}.pdf`;
}
